module.exports = __webpack_public_path__ + "static/img/mi_colegio_hor.0a4a3133.svg";